var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "comments",
      staticClass: "comments-list",
      on: { scroll: _vm.scrollHandler },
    },
    _vm._l(
      _vm.filterBy(_vm.comments, _vm.filter),
      function (comment, commentIndex) {
        return _c("figure", { key: commentIndex, staticClass: "social-grid" }, [
          _c("img", {
            staticClass: "social-grid-avatar",
            attrs: { src: comment.avatar || _vm.avatarImage },
          }),
          _vm._v(" "),
          _c("small", { staticClass: "social-grid-name" }, [
            _vm._v("\n      " + _vm._s(_vm.anonymous) + "\n    "),
          ]),
          _vm._v(" "),
          _c("time", { staticClass: "social-grid-date" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.relativizeDate(comment.createdAt)) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "social-grid-message" }, [
            _vm._v("\n      " + _vm._s(comment.message) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "social-grid-replies" },
            _vm._l(comment.replies, function (reply, replyIndex) {
              return _c(
                "div",
                {
                  key: replyIndex,
                  staticClass: "social-grid reply-split-line",
                },
                [
                  _c("img", {
                    staticClass: "social-grid-avatar",
                    attrs: { src: reply.avatar || _vm.avatarImage },
                  }),
                  _vm._v(" "),
                  _c("small", { staticClass: "social-grid-name" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(reply.name || _vm.anonymous) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("time", { staticClass: "social-grid-date" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.relativizeDate(reply.createdAt)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "social-grid-message" }, [
                    _vm._v(
                      "\n          " + _vm._s(reply.message) + "\n        "
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ])
      }
    ),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }